import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";
import { ICourtCaseConnectionType } from "../model/CourtCaseConnectionType";
import CourtCaseConnectionTypeMapper from "../service/CourtCaseConnectionTypeMapper";
import CourtCaseConnectionTypeParamMapper from "../service/CourtCaseConnectionTypeParamMapper";

export default class GetAllCourtCaseConnectionTypesInteractor {
  private resource: GetAllResourceEntriesInteractor<ICourtCaseConnectionType>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute() {
    return this.resource.execute(
      `${Constants.courtCasesPath}/connection-types`,
      CourtCaseConnectionTypeMapper,
      CourtCaseConnectionTypeParamMapper
    );
  }
}
